import { zodResolver } from '@hookform/resolvers/zod';
import { useCallback } from 'react';
import { useForm } from 'react-hook-form';
import { z } from 'zod';
import { useUpdateTransactionStatusApi } from '../api/use-update-transaction-status';
import { TransactionStatus } from '../api/transaction-types';
// Transaction Bulk Status Schema
const transactionBulkStatusFormSchema = z.object({
    status: z.nativeEnum(TransactionStatus),
});
export const useTransactionBulkStatusForm = ({ budgetId, transactionIds, onSuccess }) => {
    const form = useForm({
        resolver: zodResolver(transactionBulkStatusFormSchema),
        defaultValues: {},
    });
    // mutations
    const { mutate: updateStatus, isPending: isUpdatePending } = useUpdateTransactionStatusApi({
        onSuccess,
    });
    /**
     * Handles the form submission event, building the API payload and
     * invoking the update status mutation.
     *
     * @param values - Sanitized transaction bulk status form values.
     */
    const submitForm = useCallback((values) => {
        const payload = toRequestData(budgetId, transactionIds, values);
        updateStatus(payload);
    }, [updateStatus, budgetId, transactionIds]);
    return {
        form,
        onSubmit: form.handleSubmit(submitForm),
        isSubmitting: isUpdatePending,
    };
};
/**
 * Build the TransactionStatusRequest payload from form values.
 *
 * @param budgetId - The budget ID
 * @param expandedTransactionIds - The expanded transaction IDs including splits
 * @param formValues - The values from the bulk status form
 * @returns A fully populated TransactionStatusRequest for the update operation
 */
function toRequestData(budgetId, expandedTransactionIds, formValues) {
    return {
        budgetId,
        transactionIds: Array.from(expandedTransactionIds),
        status: formValues.status,
    };
}
